var _style, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOilyFish({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#315CA7;}\n\t.st1{fill:#29384F;}\n\t.st2{fill:#F8EEE1;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103.86,185.11c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C26.57,150.81,61.17,185.11,103.86,185.11"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.16,137.09c17.07-18.73,33.66-13.9,54.82-0.02c22.2,14.56,30.84,4.15,31.2,3.7c0.31-0.4,0.44-0.91,0.34-1.4 c-1.14-5.77-3.25-11.29-6.3-16.39c-5-8.37-12.11-14.99-20.57-19.33c-1.71-2.52-11.27-16.1-19.23-18.56 c-0.73-0.22-1.52,0.05-1.94,0.69c-0.12,0.17-2.68,4.11-2.6,12.18c-9.07,0.04-18.01,2.49-26,7.26c-8.67,5.17-16.02,15.46-20.19,23.69 c-10.59,1.34-16.47,7.35-16.73,7.62c-0.36,0.38-0.53,0.9-0.47,1.41c0.05,0.36,0.2,0.68,0.44,0.94c0.11,0.12,0.23,0.22,0.37,0.31 c5.39,3.31,10.95,3.99,13.49,4.13c0.7,2.45,2.62,7.72,7.06,12.22c0.37,0.37,0.88,0.56,1.4,0.51s0.99-0.34,1.27-0.77 C66.72,154.95,71.31,147.8,70.16,137.09z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125.63,126.6c0.05,0.36,0.21,0.67,0.43,0.92c0.37,0.41,0.93,0.63,1.52,0.54c0.94-0.14,1.6-1.01,1.46-1.95 c-0.59-4.11,4.2-7.56,4.28-7.62c0.78-0.55,0.97-1.62,0.42-2.4c-0.55-0.78-1.62-0.97-2.4-0.42 C131.07,115.86,124.74,120.37,125.63,126.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M138.09,127.76c0.31,0.34,0.74,0.54,1.19,0.56c0.45,0.02,0.9-0.15,1.24-0.46c0.33-0.3,0.54-0.74,0.56-1.19 c0-0.12,0-0.23-0.02-0.34c-0.01-0.1-0.05-0.22-0.08-0.32c-0.04-0.11-0.09-0.21-0.14-0.31c-0.3-0.49-0.84-0.8-1.4-0.82 c-0.45-0.02-0.91,0.14-1.24,0.45c-0.34,0.31-0.54,0.75-0.56,1.2C137.62,126.98,137.79,127.43,138.09,127.76z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M104.09,104.97c9.08,0,16.45-7.3,16.45-16.3s-16.45-35.44-16.45-35.44S87.65,79.68,87.65,88.68 S95.01,104.97,104.09,104.97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOilyFish);
export default __webpack_public_path__ + "static/media/Oily_fish.635f21240e60bdda64b454f987821349.svg";
export { ForwardRef as ReactComponent };